import React, { ReactElement, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import ClearIcon from "@material-ui/icons/Clear";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Paper,
    TextField,
    Typography,
    CircularProgress,
    IconButton,
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    setZS,
    setRoutergeraettyp,
    setHerstellungsjahr,
    setFirmware,
    setMACAdresse,
    setKommentar,
    setInbetriebnahmedatum,
    setWartungsintervall,
    setEditEntry,
    setSeriennummer,
    getZSs,
    getRoutergeraettypen,
    selectZSs,
    selectRoutergeraettypen,
    selectEditEntry,
    selectNewEntry,
    selectEditDirty,
    selectAktuellesRoutergeraet,
    createRoutergeraet,
    updateRoutergeraet,
    discardNew,
    discardChanges,
    deleteRoutergeraet,
    setError,
    resetError,
    selectError,
    getWartungsintervalle,
    selectWartungsintervalleList,
    selectListLoading,
    selectWartungsintervallLoading,
    selectRoutergeraettypenLoading,
    selectZeitsynchroLoading,
    selectViewMode,
    setSubnetzmaske,
    setIp,
    resetViewMode
} from "./routergeraetSlice";

import { useStyles } from "./routergeraetStyles";

import { useMsal } from "@azure/msal-react";
import { rollen, isAuthorized } from "../../../utils/auth/authConfig";
import { Zeitsynchronisationsart } from "./routergeraetTypes";
import { Autocomplete } from "@material-ui/lab";
import { routergeraet, routergeraettyp, wartungsintervall } from "../../../utils/apiTypes";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { de } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import { validate, validateHelper } from "../../../features/validate/validate";
import { globalStyles } from "../../../assets/globalStyles";




export default function RoutergeraetEdit(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();

    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [zsSelectInputValue, setZSSelectInputValue] = React.useState('');
    const [routergeraettypSelectInputValue, setRoutergeraettypSelectInputValue] = React.useState('');
    const [wartungsintervallInputValue, setWartungsintervallInputValue] = React.useState('');

    useEffect(() => {
        dispatch(getZSs());
        dispatch(getRoutergeraettypen());
        dispatch(getWartungsintervalle());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const
        zsSelectList: Zeitsynchronisationsart[] = useAppSelector(selectZSs),
        routergeraetetypSelectList: routergeraettyp[] = useAppSelector(selectRoutergeraettypen),
        editEntry: boolean = useAppSelector(selectEditEntry),
        newEntry: boolean = useAppSelector(selectNewEntry),
        aktuellesRoutergeraet: routergeraet = useAppSelector(selectAktuellesRoutergeraet),
        dirtyEdit: number = useAppSelector(selectEditDirty),
        inputError: boolean = useAppSelector(selectError),
        wartungsintervalleSelectList: Array<wartungsintervall> = useAppSelector(selectWartungsintervalleList),
        listLoading: boolean = useAppSelector(selectListLoading),
        routergeraettypenLoading: boolean = useAppSelector(selectRoutergeraettypenLoading),
        zeitsynchroLoading: boolean = useAppSelector(selectZeitsynchroLoading),
        wartungsintervallLoading: boolean = useAppSelector(selectWartungsintervallLoading),
        viewMode: boolean = useAppSelector(selectViewMode);



    function printSaveDiscardButtons() {
        return (<React.Fragment>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(createRoutergeraet(aktuellesRoutergeraet)) : dispatch(updateRoutergeraet(aktuellesRoutergeraet)) }}
                color="secondary"
                className={classes.showtriButton}
                disabled={aktuellesRoutergeraet.seriennummer == ""
                    || aktuellesRoutergeraet.firmware == ""
                    || aktuellesRoutergeraet.typ == -1
                    || !dirtyEdit
                    || inputError
                }
                style={{ minHeight: "36px" }}
            >
                {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
            </Button>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
                color="secondary"
                className={classes.showtriButton}
            >
                Abbrechen
            </Button>
        </React.Fragment>)
    }
    function confirmDeleteOfRoutergeraet() {
        dispatch(deleteRoutergeraet(aktuellesRoutergeraet));
        setOpenDeleteDialog(false);
    }

    function printEditDeleteButton() {
        if (isAuthorized([rollen.admin, rollen.betrieb]))
            return (
                <React.Fragment>
                    <Button
                        variant="contained"
                        onClick={() => {
                            dispatch(setEditEntry());

                        }}
                        color="secondary"
                        className={classes.showtriButton}
                    >
                        Bearbeiten
                    </Button>
                    { !aktuellesRoutergeraet.jemalsZugeordnet ? 
                    <Button
                        variant="contained"
                        onClick={() => setOpenDeleteDialog(true)}
                        color="secondary"
                        className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
                    >
                        Löschen
                    </Button>
                    : ""}
                    <Dialog
                        open={openDeleteDialog}
                        onClose={() => setOpenDeleteDialog(false)}
                    >
                        <DialogTitle>Router löschen</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {'Sind Sie sicher, dass Sie den Router "' +
                                    aktuellesRoutergeraet.seriennummer +
                                    '" wirklich löschen wollen?'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => setOpenDeleteDialog(false)}
                                className={classes.cancleDeleteButton}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                variant="contained"
                                onClick={confirmDeleteOfRoutergeraet}
                                className={classes.confirmDeleteButton}
                                style={{ minWidth: "120px", minHeight: "36px" }}
                            >
                                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Button
                        variant="contained"
                        onClick={() => { dispatch(resetViewMode())}}
                        color="default"
                        className={classes.showtriButton}
                    >
                        Schließen
                    </Button>
                </React.Fragment>
            );
        else return (<React.Fragment />)
    }

    function printEdit() {
        return (<Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
            <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
                <React.Fragment>
                    <Grid container spacing={4}>
                        <Grid item container xs={12}>
                            <Grid item md={3}>
                            <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                                {newEntry ? "Neuen Router anlegen" : "Bearbeiten von Router: " + aktuellesRoutergeraet.seriennummer}
                            </Typography>
                        </Grid>
                        <Grid item md={3} />
                        <Grid item md={6}>
                            {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                        </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField 
                                    className={classes.fullWidth}
                                    required={true}
                                    disabled={!editEntry}
                                    id="routergeraet-seriennummer"
                                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraet.seriennummer, "seriennummer")}
                                    helperText={validateHelper(aktuellesRoutergeraet.seriennummer)}
                                    label="Seriennummer" variant="outlined" onChange={(event) => dispatch(setSeriennummer(event.target.value))} value={aktuellesRoutergeraet.seriennummer} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                                    <DatePicker
                                        id="routergeraet-herstellungsjahr"
                                        okLabel="OK"
                                        cancelLabel="ABBRECHEN"
                                        disabled={!editEntry}
                                        openTo="year"
                                        views={["year"]}
                                        label="Herstellungsjahr"
                                        inputVariant="outlined"
                                        required={true}
                                        value={new Date(aktuellesRoutergeraet.herstellungsjahr, 1, 1)}
                                        onChange={(event) => dispatch(setHerstellungsjahr(event ? event?.getFullYear() : 0))}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="routergeraet-firmware" disabled={!editEntry}
                                    label="Firmware" variant="outlined"
                                    required={true}
                                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraet.firmware, "firmware")}
                                    helperText={validateHelper(aktuellesRoutergeraet.firmware)}
                                    inputProps={{ maxLength: 50 }}
                                    onChange={(event) => dispatch(setFirmware(event.target.value))}
                                    value={aktuellesRoutergeraet.firmware ? aktuellesRoutergeraet.firmware : ""} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="routergeraet-macadresse"
                                    inputProps={{ maxLength: 50 }}
                                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraet.macadresse, "mac")}
                                    helperText={validateHelper(aktuellesRoutergeraet.macadresse)}
                                    label="MAC Adresse"
                                    disabled={!editEntry}
                                    variant="outlined"
                                    onChange={(event) => dispatch(setMACAdresse(event.target.value))}
                                    value={aktuellesRoutergeraet.macadresse ? aktuellesRoutergeraet.macadresse : ""} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                                <DatePicker
                                    className={classes.datePicker}
                                    disabled={!editEntry}
                                    value={aktuellesRoutergeraet.inbetriebnahmedatum}
                                    format="dd.MM.yyyy "
                                    label="Inbetriebnahmedatum"
                                    okLabel="OK"
                                    cancelLabel="ABBRECHEN"
                                    inputVariant="outlined"
                                    onChange={(event) => {
                                        dispatch(
                                            setInbetriebnahmedatum(event)
                                        );
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton onClick={() =>
                                                dispatch(setInbetriebnahmedatum(null))
                                            }
                                                disabled={!editEntry}>
                                                <ClearIcon />
                                            </IconButton>
                                        )
                                    }}
                                ></DatePicker>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <Autocomplete
                                    id="select-wartungsintervall"
                                    noOptionsText={<React.Fragment>
                                        {wartungsintervallLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Wartungsintervalle"}</React.Fragment>}
                                    disabled={!editEntry}
                                    value={aktuellesRoutergeraet.wartungsintervall}
                                    onChange={(_, newValue) => {
                                        dispatch(setWartungsintervall(newValue));
                                    }}
                                    inputValue={wartungsintervallInputValue}
                                    onInputChange={(_, newInputValue) => {
                                        setWartungsintervallInputValue(newInputValue);
                                    }}
                                    options={
                                        wartungsintervalleSelectList.map((x: wartungsintervall) => x.name)}
                                    getOptionLabel={(option) => option ? option : ""}
                                    renderInput={(params) => <TextField {...params} label="Wartungsintervall" variant="outlined" />}
                                    className={classes.selectEmpty}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <Autocomplete
                                    id="select-zs"
                                    noOptionsText={<React.Fragment>
                                        {zeitsynchroLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Zeitsynchronisationsarten"}</React.Fragment>}
                                    disabled={!editEntry}
                                    value={aktuellesRoutergeraet.zeitsynchronisationsart}
                                    onChange={(_, newValue) => {
                                        dispatch(setZS(newValue));
                                    }}
                                    inputValue={zsSelectInputValue}
                                    onInputChange={(_, newInputValue) => {
                                        setZSSelectInputValue(newInputValue);
                                    }}
                                    options={
                                        zsSelectList.map((x: Zeitsynchronisationsart) => x.name)}
                                    getOptionLabel={(option) => option ? option : ""}
                                    renderInput={(params) => <TextField {...params} label="Zeitsynchronisationsart" variant="outlined" />}
                                    className={classes.selectEmpty}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <Autocomplete
                                    noOptionsText={<React.Fragment>
                                        {routergeraettypenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Routertypen"}</React.Fragment>}
                                    id="select-typ"
                                    disabled={!editEntry}
                                    value={routergeraetetypSelectList.find((x: routergeraettyp) => x.id == aktuellesRoutergeraet.typ)}
                                    onChange={(_, newValue) => {
                                        if (newValue) dispatch(setRoutergeraettyp(newValue.id));
                                    }}
                                    inputValue={routergeraettypSelectInputValue}
                                    onInputChange={(_, newInputValue) => {
                                        setRoutergeraettypSelectInputValue(newInputValue);
                                    }}
                                    options={routergeraetetypSelectList}
                                    getOptionLabel={(option) => option ? option.hersteller + ": " + option.typ : ""}
                                    renderInput={(params) => <TextField {...params} label="Routertyp" variant="outlined" required={true} />}
                                    className={classes.selectEmpty}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="routergeraet-ip" disabled={!editEntry}
                                    label="IP-Adresse" variant="outlined"
                                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraet.ipadresse, "ip")}
                                    helperText={validateHelper(aktuellesRoutergeraet.ipadresse)}
                                    inputProps={{ maxLength: 50 }}
                                    onChange={(event) => dispatch(setIp(event.target.value))}
                                    value={aktuellesRoutergeraet.ipadresse ? aktuellesRoutergeraet.ipadresse : ""} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="routergeraet-subnetzmaske"
                                    inputProps={{ maxLength: 50 }}
                                    error={validate(dispatch, setError, resetError, aktuellesRoutergeraet.subnetzmaske, "subnetzmaske")}
                                    helperText={validateHelper(aktuellesRoutergeraet.subnetzmaske)}
                                    label="Subnetzmaske"
                                    disabled={!editEntry}
                                    variant="outlined"
                                    onChange={(event) => dispatch(setSubnetzmaske(event.target.value))}
                                    value={aktuellesRoutergeraet.subnetzmaske ? aktuellesRoutergeraet.subnetzmaske : ""} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="routergeraet-kommentar"
                                    multiline
                                    rows={4}
                                    rowsMax={8}
                                    label="Kommentar" disabled={!editEntry}
                                    variant="outlined"
                                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                                    value={aktuellesRoutergeraet.kommentar ? aktuellesRoutergeraet.kommentar : ""} />
                            </FormControl>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </form>
        </Paper>)
    }


    return (<React.Fragment>
        {viewMode ? printEdit() : ""}
    </React.Fragment>
    );
}
